import React, {useState} from 'react';
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import {AddButton} from "../../../AddButton/AddButton";
import {DataGrid, ruRU} from "@material-ui/data-grid";
import {DeleteButton} from "../../../DeleteButton/DeleteButton";
import FormHelperText from "@material-ui/core/FormHelperText";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {MasterOfActsAPI} from "../../../../api/api";
import {GridCellExpand} from "../../../GridCellExpand/GridCellExpand.jsx";
import LibraryDialog from "../../../../containers/LibraryDialog/LibraryDialog.jsx";


const useStyles = makeStyles(theme => ({
    tableError: {
        borderColor: theme.palette.error.main
    },
}))

const renderCellExpand = (params) => {
    return (
        <GridCellExpand
            value={params.value ? params.value.toString() : ''}
            width={params.colDef.computedWidth}
        />
    )
}

const offenceSelectColumns = [
    {field: 'sequenceNumber', headerName: '№', width: 90},
    {field: 'normativeDocument', headerName: 'Документ', minWidth: 180, renderCell: renderCellExpand},
    {field: 'normativeChapter', headerName: 'Глава', minWidth: 180, renderCell: renderCellExpand},
    {field: 'shortText', headerName: 'Пункт', minWidth: 180, flex: 1, renderCell: renderCellExpand},
]

export const NormativeArticlesTable = ({value, setFieldValue, name, disabled, error, touched}) => {
    const classes = useStyles()

    const [isOpenOffenseDialog, setIsOpenOffenseDialog] = useState(false)
    const [selectionModel, setSelectionModel] = useState([]);

    const openOffenseDialog = () => {
        setIsOpenOffenseDialog(true)
    }

    const closeOffenseDialog = () => {
        setIsOpenOffenseDialog(false)
    }

    const onCommitOffense = async (offense) => {
        const normativeDocumentResponse = await MasterOfActsAPI.getNormativeDocument(offense.normative_document)
        const normativeChapterResponse = await MasterOfActsAPI.getNormativeChapter(offense.normative_chapter)

        setFieldValue(name, [...value, {
            id: offense.id,
            reference: offense.reference,
            shortText: offense.short_text,
            normativeDocument: normativeDocumentResponse.data.name,
            normativeChapter: normativeChapterResponse.data.name,
        }])
    }

    const onDeleteOffence = () => {
        setFieldValue(name, value.filter(f => f.id !== selectionModel[0]))
        setSelectionModel([])
    }

    return <Grid container direction={"column"}>
        <Grid container item alignItems={"center"}>
            <Typography variant={"body1"}>
                Нарушенные пункты
            </Typography>
            {!disabled ? <Grid container xs item justifyContent={"space-between"}>
                <Grid item>
                    <AddButton onClick={openOffenseDialog}/>
                </Grid>
                <Grid item>
                    <DeleteButton onClick={onDeleteOffence} disabled={selectionModel.length === 0}/>
                </Grid>
            </Grid> : null}
        </Grid>
        <Grid item style={{height: 300, width: '100%'}}>
            <DataGrid rows={value?.map((el, index) => ({...el, sequenceNumber: index + 1}))}
                      columns={offenceSelectColumns}
                      density={'compact'}
                      localeText={ruRU?.props?.MuiDataGrid?.localeText || ruRU?.components?.MuiDataGrid?.defaultProps?.localeText}
                      onSelectionModelChange={(newSelectionModel) => {
                          setSelectionModel(newSelectionModel)
                      }}
                      classes={{root: touched && Boolean(error) ? classes.tableError : undefined}}
                      selectionModel={selectionModel}
            />
        </Grid>
        <FormHelperText error={touched && Boolean(error)}>{touched && Boolean(error) ? error : null}</FormHelperText>
        {!disabled ?
            <LibraryDialog
                open={isOpenOffenseDialog}
                shadow={false}
                onCommitNormativeArticle={onCommitOffense}
                onClose={closeOffenseDialog}
            />
            : null}
    </Grid>
}